<template>
  <div class="main-content">
    <div class="row">
      <div class="col-sm-12">
        <div class="row mt-8">
          <div class="col-sm-12">
            <div class="container-fluid">
              <div class="row">
                <div class="col">
                  <div class="card">
                    <div class="card-body">
                      <font size="6">Menú de acceso rápido</font>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container-fluid">
              <div v-if="arrayBarra[0]['state'] === true || arrayBarra[1]['state'] === true || arrayBarra[2]['state'] === true" class="row">

                <div class="col">
                  <router-link v-if="arrayBarra[0]['state'] === true" class="card sombra zoom" to="/admin/cuentas">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/contabilidad.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">CUENTAS</font>
                    </div>
                  </router-link>
                  <router-link v-else class="card sombra zoom" to="/admin/menu">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/prohibicion.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">SIN PERMISOS</font>
                    </div>
                  </router-link>
                </div>

                <div class="col">
                  <router-link v-if="arrayBarra[1]['state'] === true" class="card sombra zoom" to="/admin/cajas">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/dinero.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">CAJAS</font>
                    </div>
                  </router-link>
                  <router-link v-else class="card sombra zoom" to="/admin/menu">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/prohibicion.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">SIN PERMISOS</font>
                    </div>
                  </router-link>
                </div>

                <div class="col">
                  <router-link v-if="arrayBarra[2]['state'] === true" class="card sombra zoom" to="/admin/products/productos">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/productos.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">PRODUCTOS</font>
                    </div>
                  </router-link>
                  <router-link v-else class="card sombra zoom" to="/admin/menu">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/prohibicion.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">SIN PERMISOS</font>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-8">
          <div class="col-sm-12">
            <!-- <h5 class="section-semi-title">Dashboard</h5> -->
            <div class="container-fluid">
              <div v-if="arrayBarra[3]['state'] === true || arrayBarra[4]['state'] === true || arrayBarra[5]['state'] === true" class="row">

                <!-- <div class="col"> -->
                  <!-- <router-link v-if="arrayBarra[3]['state'] === true" class="card sombra zoom" to="/admin/productos/transporte">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/fabrica.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">TRANSPORTE</font>
                    </div>
                  </router-link> -->
                  <!-- <router-link class="card sombra zoom" to="/admin/menu">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/prohibicion.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">SIN PERMISOS</font>
                    </div>
                  </router-link> -->
                <!-- </div> -->

                <div class="col">
                  <router-link v-if="arrayBarra[4]['state'] === true" class="card sombra zoom" to="/admin/personas/empleados">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/empleados.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">EMPLEADOS</font>
                    </div>
                  </router-link>
                  <router-link v-else class="card sombra zoom" to="/admin/menu">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/prohibicion.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">SIN PERMISOS</font>
                    </div>
                  </router-link>
                </div>

                <div class="col">
                  <router-link v-if="arrayBarra[5]['state'] === true" class="card sombra zoom" to="/admin/personas/proveedores">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/grupo.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">PROVEEDORES</font>
                    </div>
                  </router-link>
                  <router-link v-else class="card sombra zoom" to="/admin/menu">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/prohibicion.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">SIN PERMISOS</font>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-8">
          <div class="col-sm-12">
            <div class="container-fluid">
              <div v-if="arrayBarra[6]['state'] === true || arrayBarra[7]['state'] === true || arrayBarra[8]['state'] === true" class="row">

                <div class="col">
                  <router-link v-if="arrayBarra[6]['state'] === true" class="card sombra zoom" to="/admin/venta/nuevo">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/rebaja.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">VENTAS</font>
                    </div>
                  </router-link>
                  <router-link v-else class="card sombra zoom" to="/admin/menu">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/prohibicion.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">SIN PERMISOS</font>
                    </div>
                  </router-link>
                </div>

                <div class="col">
                  <router-link v-if="arrayBarra[7]['state'] === true" class="card sombra zoom" to="/admin/compra/nuevo">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/ventas.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">COMPRAS</font>
                    </div>
                  </router-link>
                  <router-link v-else class="card sombra zoom" to="/admin/menu">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/prohibicion.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">SIN PERMISOS</font>
                    </div>
                  </router-link>
                </div>

                <div class="col">
                  <router-link v-if="arrayBarra[8]['state'] === true" class="card sombra zoom" to="/admin/reports">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/big-data.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">REPORTES</font>
                    </div>
                  </router-link>
                  <router-link v-else class="card sombra zoom" to="/admin/menu">
                    <div class="card-body" align="center">
                      <img src="/assets/img/menu/prohibicion.png" class="img-fluid" height="100" width="100">
                    </div>
                    <div class="card-footer" align="center">
                      <font class="letra">SIN PERMISOS</font>
                    </div>
                  </router-link>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import Ls from '../../../services/ls'

export default {
  components: {

  },
  data () {
    return {
      arrayPermisos: null,
      arrayBarra: [
        { id: 3, state: false},
        { id: 7, state: false},
        { id: 30, state: false},
        { id: 96, state: false},
        { id: 39, state: false},
        { id: 90, state: false},
        { id: 63, state: false},
        { id: 82, state: false},
        { id: 103, state: false},
      ]
    }


  },
  mounted () {
    this.validarPermisos()
  },
  methods: {
    validarPermisos () {
      // Aqui extraer los permisos de la SiteBar
      this.arrayPermisos = JSON.parse(Ls.get('auth.roles'))
      //trabajar con idpermits
      for (let i = 0; i < this.arrayPermisos.length; i++) {

        for (let j = 0; j < this.arrayBarra.length; j++){
          if(this.arrayPermisos[i]['idpermits'] === this.arrayBarra[j]['id'] && this.arrayPermisos[i]['state'] === 1){
            this.arrayBarra[j]['state'] = true;
          }
        }

      }
    },
  }
}
</script>
<style>
.sombra {
  background-color: rgb(241, 241, 241);
  border-radius: 10px;
  box-shadow: 10px 10px 12px #666;
}

.zoom{
  transition: transform .0.5s;
}
 .zoom:hover{
   transform: scale(1.05);
}
.letra {
  font-family: 'Poppins', sans-serif;
  font-size: 1.5vw;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/admin/dashboard/Menu.vue